import React from 'react'
import { EColor } from '@frontend/pole-ui/lib/common/constants'
import type { IIconProps } from '@frontend/pole-ui/lib/components/Icon'
import { EIconSize } from '@frontend/pole-ui/lib/components/Icon'
import { ActiveIcon } from '@frontend/pole-ui/lib/components/Icon/svg/ActiveIcon'

export const CONDITION_ICON_PROPS: IIconProps = {
  component: <ActiveIcon />,
  style: { color: EColor.GREEN },
  size: EIconSize.M,
}
export const NUMBER_OF_CONDITIONS = 4
